module.exports = __webpack_public_path__ + "img/IMG_6883.fd0bc435.webp";